import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/lib/utils";

type DotListItemProps = {
  dot?: boolean;
  children: ReactNode;
} & ComponentProps<"div">;

const DotListItem = ({
  dot = true,
  children,
  className,
  ...rest
}: DotListItemProps) => {
  return (
    <div className={cn("flex items-center [&>*+*]:ml-3", className)} {...rest}>
      {dot && (
        <span className="size-2 rounded-full bg-sky-100 shrink-0" />
      )}
      <span className="flex-1 text-copy">{children}</span>
    </div>
  );
};

export { DotListItem };
